<template>
	<div style="padding: 20px 10px 0 0;">
		<el-dialog :title="title" :visible.sync="show" width="30%" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-form ref="forms" :model="forms" label-width="80px">
				<el-form-item label="商户名" prop="name" :rules="[{required:true,message:'请输入商户名'}]">
					<el-input v-model="forms.name" :maxlength="50"></el-input>
				</el-form-item>
				<el-form-item label="性别">
					<el-radio v-model="forms.sex" label="男"></el-radio>
					<el-radio v-model="forms.sex" label="女"></el-radio>
				</el-form-item>
				<el-form-item label="手机号" prop="phone" :rules="[{required:true,pattern:$store.state.phone,message:'请输入正确手机号'}]">
					<el-input v-model="forms.phone" :maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" prop="idCard" :rules="[{required:true,pattern:$store.state.id,message:'请输入正确身份证号'}]">
					<el-input v-model="forms.idCard" :maxlength="18"></el-input>
				</el-form-item>
				<el-form-item  label="商铺号" :rules="[{required:true,message:'请选择商铺号'}]">
					<el-select :disabled="title=='修改'" v-model="forms.shopNum">
						<el-option v-for="s in spList" :value="s.shopNum" :label="s.shopNum"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
		<div class="bottom10 flex sb">
			<div class="flex y">
			<!-- 	<span>管理员姓名</span> -->
				<el-form :inline="true">
					<el-form-item label="商户名">
						<el-input class="left10 right10" v-model="form.name" placeholder="请输入商户名" style="width: 150px;" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div>
				<!-- <el-button type="primary" @click="addRow">新增</el-button> -->
			</div>
		</div>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="name" label="商户名">
				<template slot-scope="{row}">
					{{row.name?row.name:'未完善'}}
				</template>
			</el-table-column>
			<el-table-column prop="phone" label="联系电话">
				<template slot-scope="{row}">
					{{row.phone?row.phone:'未完善'}}
				</template>
			</el-table-column>
			<el-table-column prop="idCard" label="身份证号">
				<template slot-scope="{row}">
					{{row.idCard?row.idCard:'未完善'}}
				</template>
			</el-table-column>
			<el-table-column prop="shopNum" label="商户号">
				<template slot-scope="{row}">
					{{row.shopNum?row.shopNum:'未完善'}}
				</template>
			</el-table-column>

			<el-table-column label="商户一卡通号">
				<template slot-scope="{row}">
					{{row.oneCardSolution!=null?row.oneCardSolution.cardNo:'未完善'}}
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="操作">
				<template slot-scope="{row}">
					<!-- <el-button type="text" @click="delRow(row)">删除</el-button>
					<el-button type="text" @click="setRow(row)">编辑</el-button> -->
					<el-button type="text" @click="setRow(row)">设置管理员</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				oldForm: "",
				form: {
					name:'',
					//roleId:12,
					pageNum:'1',
					pageSize:'10',
					deptId:112			
				},
				forms:{
					roleId:12,
					name:'',
					sex:'',
					phone:'',
					idCard:'',
					shopNum:''
				},
				title: "新增",
				show: false,
				page: 1, //当前页
				size: 10, //页大小
				name: "", //模糊查询
				data: [], //表格数据
				oldForms:{},
				spList:[]
			}
		},
		methods: {
			ok() {
				this.$refs.forms.validate((valid) => {
					if (valid) {
						let url = "/api/user/editUser"
						if (this.title[0] == "新") {
							url = "/api/user/addUser"
						}
						this.$http.post(url, this.forms).then(res => {
							if (res.data.code == 0) {
								this.$message.success(res.data.message);
								this.show = false
								this.getAll()
							}
							if (res.data.code == -1) {
								this.$message.error(res.data.message)
							}
							if (res.data.code == 500) {
								this.$message.error("信息不匹配,修改失败")
							}
						})
					} else {
						return false;
					}
				});
			},
			getAll() { //获取表格分页数据
				this.$http.get(`/api/system/user/list`, {
					params:{
						...this.form
					}
				}).then(res => {
					this.data = res.data.rows
					this.totalNum = res.data.total
				})
			},
			setRow(obj) {
				this.title = "修改"
				this.forms = JSON.parse(JSON.stringify(obj))
				this.show = true
			},
			addRow() {
				this.title = "新增"
				this.forms = JSON.parse(JSON.stringify(this.oldForms))
				this.show = true
				this.getSp()
			},
			getSp(){
				this.$http.get("/api/user/getAvailableShopNum").then(res=>{
					console.log(res)
					this.spList=res.data.data
				}).catch(err=>{
					console.log(err)
				})
			},
			delRow(obj) { //删除被点击
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete(`/api/user/deleteUser`, {
						params: {
							id: obj.id
						}
					}).then(res => {
						if (res.data.code == 0) {
							this.$message.success(res.data.message)
							this.getAll()
						}
					})
				}).catch(() => {});
			}
		},
		mounted() {
			this.oldForms = JSON.parse(JSON.stringify(this.forms))
			this.getAll()
		}
	}
</script>

<style>
</style>
